import React, { useState } from 'react';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export default function EditableTitle({ story }) {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(story.title || "Untitled Story");
  const [saving, setSaving] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateDoc(doc(db, "stories", story.id), {
        title: title,
        updatedAt: serverTimestamp()
      });
      setIsEditing(false);
    } catch (err) {
      console.error("Error updating title:", err);
      alert("Failed to update title. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setTitle(story.title || "Untitled Story");
    setIsEditing(false);
  };

  return (
    <div className="mb-4">
      {isEditing ? (
        <div>
          <input 
            type="text" 
            value={title} 
            onChange={(e) => setTitle(e.target.value)}
            className="w-full text-3xl font-bold text-gray-900 mb-2 p-3 border-2 border-gray-300 rounded-md focus:border-blue-500 focus:outline-none"
            autoFocus
            placeholder="Enter story title..."
          />
          <div className="flex gap-2 flex-wrap">
            <button 
              onClick={handleSave} 
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
            >
              {saving ? "Saving..." : "Save"}
            </button>
            <button 
              onClick={handleCancel}
              disabled={saving}
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="flex items-start gap-3 group">
          <h1 className="text-3xl font-bold text-gray-900 flex-1 min-w-0">
            {title}
          </h1>
          <button 
            onClick={handleEdit} 
            className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md text-sm font-medium flex-shrink-0"
          >
            ✏️ Edit
          </button>
        </div>
      )}
    </div>
  );
}